import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { useContext } from 'react';
import { InvoiceDetailsContext, InvoiceDetailsValues } from '../contexts/InvoicesContext';
import { CloseDialogAction } from '../../../components/shared/dialogs/CloseDialogAction';

export function AcceptModal() {
  const { t, closesAcceptModal, isOpenAcceptModal, acceptItem, acceptId } = useContext(InvoiceDetailsContext) as InvoiceDetailsValues;

  const handleClose = () => {
    closesAcceptModal();
  };

  return (
    <Dialog onClose={handleClose}
      open={isOpenAcceptModal}>
      <DialogTitle>
        {t('acceptModalTitle')}
        <CloseDialogAction onCancel={handleClose} />
      </DialogTitle>
      <DialogContent>
        {t('acceptInvoice')}
      </DialogContent>
      <DialogActions>
        <Stack direction={{ xs: 'column', md: 'row' }}
          gap='6px'
          width='100%'>
          <Button variant='secondary'
            fullWidth
            size="lg"
            onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant='primary'
            fullWidth
            size="lg"
            onClick={() => acceptItem(acceptId ?? -1)}>
            {t('accept')}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
